import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helloTitle: {
    defaultMessage: 'Hello, {name}',
    id: 'm/FybZ',
    description: 'Onboarding step title',
  },
  personalInfoSubTitle: {
    defaultMessage: 'Add your personal information.',
    id: 'VB7Mvv',
    description: 'Onboarding step subtitle',
  },
  vehicleQualifyTitle: {
    defaultMessage: 'Does your vehicle qualify?',
    id: 'hafaT4',
    description: 'Does your vehicle qualify (onboarding step title)',
  },
  skipButtonText: {
    defaultMessage: 'SKIP',
    id: 'q4g4zW',
    description: 'SKIP button text',
  },
  paymentDetailsTitle: {
    defaultMessage: 'Payment details',
    id: 'NQlgHT',
    description: 'Payment details (onboarding step title)',
  },
  vehicleInfoTitle: {
    defaultMessage: 'Vehicle info',
    id: 'c0G8wG',
    description: 'Vehicle info (onboarding step title)',
  },
  payoutsTitle: {
    defaultMessage: 'Payouts',
    id: 'n3sp5y',
    description: 'Payouts (onboarding step title)',
  },
  ukLicensingAuthorityStepTitle: {
    defaultMessage: 'What authority issued your Private hire driver license?',
    id: '5mMUid',
    description: 'Onboarding step title',
  },
  vehicleStepTitle: {
    defaultMessage: 'What vehicle do you have?',
    id: '8ptTVr',
    description: 'Onboarding step title',
  },
  personalInformationStepTitle: {
    defaultMessage: 'Personal Information',
    id: 'v3duLT',
    description: 'Onboarding step title',
  },
  ukLicensingAuthorityMissingTitle: {
    defaultMessage: "To proceed you need to have driver's license",
    id: 'nPyDZe',
    description: 'Onboarding step title',
  },
});
